module.exports = __webpack_public_path__ + "img/redEnvelopedRainSuccessImage.2ba11fff.png";